import { ButtonGroup } from 'react-bootstrap'
import React from 'react'
import { BusyButton } from '../BusyButton'

export type SaveCancelButtonsProps = {
  onSave?: any
  onCancel?: () => void
  saveBusyText?: string
  saveText?: string
  saveTitle?: string
  cancelText?: string
  cancelTitle?: string
  disabled?: boolean
  isBusy?: boolean
  cancelType?: 'button' | 'reset'
  saveType?: 'button' | 'submit'
  saveIcon?: string
  size?: 'sm' | 'lg'
}
/**
 * The default layout for save and cancel button
 */
export const SaveCancelButtons = ({
  size,
  onSave,
  onCancel,
  saveBusyText = 'Saving...',
  saveText = 'Save',
  cancelText = 'Cancel',
  disabled,
  isBusy,
  cancelType,
  saveType,
  saveIcon = 'save',
  saveTitle = 'Save changes',
  cancelTitle = 'Cancel changes',
}: SaveCancelButtonsProps) => {
  return (
    <ButtonGroup size={size}>
      <BusyButton
        variant="primary"
        icon={saveIcon}
        text={saveText}
        disabled={disabled}
        isBusy={isBusy}
        onClick={onSave}
        busyText={saveBusyText}
        type={saveType}
        title={saveTitle}
      />
      <BusyButton
        variant="outline-primary"
        type={cancelType}
        text={cancelText}
        icon="ban"
        onClick={onCancel}
        disabled={isBusy}
        title={cancelTitle}
      />
    </ButtonGroup>
  )
}
